import _objectSpread from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import omit from 'lodash/omit';
var omitQueryKeyList = ['type', 'noticeSubType',
// 公告子类型
'noticeType',
// 公告类型
'active',
// 首页数字资产和web3应用选中
'targetPageName', 'projectedId', 'projectType', 'storeNo',
// 项目storeNo
'keep' // 市场中弹出层里面的出价订单tab选中后需要带上回填参数，用于出价转售失败以后返回并打开选中出价订单tab
];
export default {
  name: 'TabBar',
  props: {
    defaultActive: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      active: this.defaultActive
    };
  },
  watch: {
    defaultActive: function defaultActive(n) {
      this.active = n;
    }
  },
  methods: {
    handleSetTabBarIcon: function handleSetTabBarIcon(data, index) {
      var activeIcon = data.activeIcon,
        icon = data.icon;
      return this.active === index ? activeIcon : icon;
    },
    handleChange: function handleChange(value) {
      var query = this.$route.query;
      var to = this.data[value].to;
      this.$emit('change', value);
      var params = omit(query, omitQueryKeyList);
      // this.$store.commit('user/RESET_KEEP_ALIVE') // 统一清除缓存
      this.$router.replace(_objectSpread(_objectSpread({}, to), {}, {
        query: _objectSpread(_objectSpread({}, params), to.query)
      }));
    }
  }
};